export default __webpack_public_path__ + "static/media/a.eaff25c8.wav";